import React from "react";
import Axios from 'axios'
import CircularDeterminate from "../_Components/CircularDeterminate";
import GerenteTemplate from "./GerenteTemplate"
import moment from 'moment';
import { Link } from 'react-router-dom';
import API from '../Utils/api'

export class ImprimirCartelasAvulsas extends React.Component {
  constructor(props) {
    window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("user")),
      cambistas: [],
      cambistaSelecionado: null,
      quantidade: 0,
      series: [],
      subSeries: [],
      generate: false,
      cartelasDisponiveis: 0,
      statusVenda: false,
      currentSerie: null,
      parametros: null,
    };
    this.getParametros()
    this.currentUser()
    this.getCambistas();
    this.getSeries();
    this.getSubSeries()
    this.getCartelasDisponiveis()
    
    this.imprimirSerie = this.imprimirSerie.bind(this)
    this.imprimirSeriePanfleto = this.imprimirSeriePanfleto.bind(this)
    this.setQuantidade = this.setQuantidade.bind(this)
    this.setCambista = this.setCambista.bind(this)
    this.setCambistaCriarPedidos = this.setCambistaCriarPedidos.bind(this);
    this.statusVenda()
    if (localStorage.getItem('serie')) {
      this.serieSetBusy(localStorage.getItem('serie'), false);
    }
  }


  async getParametros() {
    try {
      const response = await API.get("/api/parametros/");
      this.setState({ parametros: response.data });

    } catch (err) {
      console.log(err);
    }
  }

  async serieSetBusy(_id, isBusy) {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem('apiUrl')
      })
      const response = await axiosInstance.put('series/set-busy', { _id, isBusy })
    } catch (err) {
      console.log(err)
    }
  }

  async serieSetNumero(_id, numero) {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem('apiUrl')
      })
      const response = await axiosInstance.put('series/atualizar-numero-serie', { _id, numero })
    } catch (err) {
      console.log(err)
    }
  }

  async serieIsBusy(serieId) {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem('apiUrl')
      })
      const response = await axiosInstance.post('series/is-busy', { id: serieId })
      if (response.data) {

        alert("Acesso negado! Essa mesma série está aberta em outra aba/ ou computador!")
      }
      else {
        localStorage.setItem('serie', serieId);
        this.props.history.push('/gerente-criar-pedidos')
      }

    } catch (err) {
      console.log(err)
    }
  }

  async currentUser() {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem('apiUrl')
      })
      const response = await axiosInstance.get('usuarios/' + this.state.user._id)
      this.setState({ user: response.data })
    } catch (err) {
      console.log(err)
    }
  }


  async statusVenda() {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem('apiUrl')
      })
      const response = await axiosInstance.get('parametros/venda-status', {})
      this.setState({ statusVenda: response.data })
    } catch (err) {
      console.log(err)
    }
  }

  async gerarPedidoAvulso(e) {
    e.target.disabled = true;
    var serie = JSON.parse(this.state.currentSerie)

    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem('apiUrl')
      })
      const transacaoResponse = await axiosInstance.post(
        'transacoes/criar-transacao',
        {
          data: new Date(),
          documento: 'Documento Avulso',
          valor: serie.cartelas.length * parseFloat(serie.cartelas[0].valor),
          emissorId: "5efa084f848650c6b2f01387",
          receptorId: serie.cambistaId._id,
          tipo: 'Venda',
          observacao: 'VENDA AVULSA',
          status: true,
          natureza: 'ENTRADA',
          isEfetivada: false,
          taxaComissao: serie.cartelas.length * this.state.parametros.baseComissaoCambista
        }
      )

      if (transacaoResponse.data) {
        const pedidoResponse = await axiosInstance.post(
          'pedidos/validar-serie-como-avulsa',
          {
            serieId: serie._id,
            comissao: serie.cartelas.length * this.state.parametros.baseComissaoCambista,
            clienteId: "5efa084f848650c6b2f01387",
            cambistaId: serie.cambistaId._id,
            gerenteId: this.state.user._id,
            recebido: true,
            transacaoId: transacaoResponse.data._id
          }
        )
      }
      alert("TODAS AS CARTELAS DA SERIA FORAM VENDIDAS COMO AVULSA!")
      window.location.reload()
    }
    catch (err) {
      console.log(err)
    }

  }
  
  async increasePrintNumber(e,_id) {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem('apiUrl')
      })
      const response = await axiosInstance.put('series/increase-printnumber',{_id : _id});
      this.serieSetNumero(JSON.parse(e.target.accessKey).serie._id, JSON.parse(e.target.accessKey).index)
      localStorage.setItem('printItem', JSON.stringify(JSON.parse(e.target.accessKey).serie))
      localStorage.setItem('nSerie', JSON.stringify(JSON.parse(e.target.accessKey).index))
      window.location.href = '/imprimir-serie?serie=' + JSON.parse(e.target.accessKey).serie._id
    } catch (err) {
      console.log(err)
    }
  }

  async increasePrintNumberPanfleto(e,_id) {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem('apiUrl')
      })
      const response = await axiosInstance.put('series/increase-printnumber',{_id : _id});
      this.serieSetNumero(JSON.parse(e.target.accessKey).serie._id, JSON.parse(e.target.accessKey).index)
      localStorage.setItem('printItem', JSON.stringify(JSON.parse(e.target.accessKey).serie))
      localStorage.setItem('nSerie', JSON.stringify(JSON.parse(e.target.accessKey).index))
      window.location.href = '/imprimir-serie-qrcode?serie=' + JSON.parse(e.target.accessKey).serie._id
    } catch (err) {
      console.log(err)
    }
  }


  imprimirSerie(e) {
    this.increasePrintNumber(e,JSON.parse(e.target.accessKey).serie._id);
    if(JSON.parse(e.target.accessKey).serie?.printNumber){
      alert("Você já imprimiu essa série antes! Registrando numero de impressões.")
    }

  }

  imprimirSeriePanfleto(e) {
    this.increasePrintNumberPanfleto(e,JSON.parse(e.target.accessKey).serie._id);
    if(JSON.parse(e.target.accessKey).serie?.printNumber){
      alert("Você já imprimiu essa série antes! Registrando numero de impressões.")
    }

  }

  getCartelasDisponiveis() {
    this.state.series.map(serie => {
      this.state.cartelasDisponiveis += serie.cartelas.length;
      this.setState({ cartelasDisponiveis: this.state.cartelasDisponiveis })
      this.forceUpdate()
    })
  }

  setCambistaCriarPedidos(e) {
    this.serieIsBusy(e.target.accessKey)
  }

  setQuantidade(e) {
    this.setState({ quantidade: parseInt(e.target.value) })
  }

  setCambista(e) {
    this.setState({ cambistaSelecionado: JSON.parse(e.target.value) })
  }


  formatDate(data) {
    return moment(data).add(0, 'days').format('DD-MM-YYYY')
  }
  getUser = async (e) => {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("usuarios/user", {
        id: this.state.user._id
      });

      window.localStorage.setItem("user", JSON.stringify(response.data[0]));
      this.setState({ user: response.data[0] });
    } catch (err) {
      console.log(err);
    }

  };

  compararNome(a, b) {
    if (a.nome.toLowerCase() > b.nome.toLowerCase()) {
      return 1;
    }
    if (a.nome.toLowerCase() < b.nome.toLowerCase()) {
      return -1;
    }

    return 0
  }

  getCambistas = async (e) => {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("usuarios/listar-ativos-por-tutor", {
        tutorId: this.state.user._id
      });
      this.setState({ cambistas: response.data.sort(this.compararNome) });

    } catch (err) {
      console.log(err);
    }
  };

  getSeries = async (e) => {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("series/por-gerente", { gerenteId: this.state.user._id, tipo: 'Serie' });

      this.setState({ series: response.data });
      this.getCartelasDisponiveis()
    } catch (err) {
      console.log(err);
    }
  };

  getSubSeries = async (e) => {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("series/por-gerente", { gerenteId: this.state.user._id, tipo: 'Subserie' });

      this.setState({ subSeries: response.data });
      console.log(response.data)
    } catch (err) {
      console.log(err);
    }
  };

  async gerarSerie(isPanfleto) {

    this.setState({ generate: true })
    if (this.state.quantidade == 0) {
      alert("Selecione a quantidade de cartelas!")
      window.location.reload(false);
    }
    else if (!this.state.cambistaSelecionado) {
      alert("Selecione um cambista!")
      window.location.reload()
    }
    if (this.state.quantidade > 0 && this.state.cambistaSelecionado) {
      try {
        var axiosInstance = new Axios.create({
          baseURL: window.localStorage.getItem("apiUrl")
        });
        const response = await axiosInstance.post("series/seller-extract", {
          cambistaId: this.state.cambistaSelecionado._id,
          gerenteId: this.state.user._id,
          serieLength: parseInt(this.state.quantidade),
          isPanfleto: isPanfleto
        });
        if(response)window.location.reload()
      } catch (err) {
        console.log(err);
      }
    }
  }

  testunselect(e) {
    e.target.selected = false;
    e.target.checked = false;
    // e.target.disabled = true;
    e.target.focused = false;
  }

  setCurrentSerie(e) {
    this.setState({ currentSerie: e.target.accessKey })
  }


  contemAcartela(cartelas, codigo) {
    var resposta = "NÃO"
    cartelas.map(cartela => {
      if (cartela.codigo == codigo) {
        resposta = "SIM"
      }
    })
    return resposta;
  }

  conteudoValido() {
    return <div>

      <div class="modal w-50" id="exampleModal2" style={{ marginLeft: '20em' }} tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Alerta</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <p>Validar todos como avulso!</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn-fill btn btn-secondary" data-dismiss="modal">Cancelar</button>
              <button type="button" data-dismiss="modal" onClick={this.gerarPedidoAvulso.bind(this)} class="btn-fill btn btn-primary">Confirmar</button>
            </div>
          </div>
        </div>
      </div>


      <div class="modal w-50" id="exampleModal3" style={{ marginLeft: '20em' }} tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">ATENÇÃO</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <p>Escolha o tipo de cartela dessa série.</p>
            </div>
         
              {this.state.user.isApp? 
                <div class="modal-footer">
                  <button type="button" class="btn-fill btn btn-success" data-dismiss="modal" onClick={() => {this.gerarSerie(true)}}>Cartela panfleto</button>
                </div>       
              :
              <div class="modal-footer">
                <button type="button" class="btn-fill btn btn-primary" data-dismiss="modal" onClick={() => {this.gerarSerie(false)}}>Cartela avulsa</button>
                <button type="button" class="btn-fill btn btn-success" data-dismiss="modal" onClick={() => {this.gerarSerie(true)}}>Cartela panfleto</button>
              </div>
              
              }

          </div>
        </div>
      </div>


      <div class="content">

        {this.state.generate ? (
          <CircularDeterminate
            geraLote={true}
            max={100}
          ></CircularDeterminate>
        ) : (
          ""
        )}
        {window.screen.width > 1 ?

          <div className="container-fluid" >
            <div class="row pl-5">
              <div class="col">
                <span class="font-weight-bold">Quantidade:</span><br />
                <select disabled={this.state.cartelasDisponiveis < 10} onChange={this.setQuantidade} class="custom-select">
                  <option selected>Nenhum...</option>
                  <option class={this.state.cartelasDisponiveis >= 10 ? "" : "collapse"} value="10">10</option>
                  <option class={this.state.cartelasDisponiveis >= 20 ? "" : "collapse"} value="20">20</option>
                  <option class={this.state.cartelasDisponiveis >= 30 ? "" : "collapse"} value="30">30</option>
                  <option class={this.state.cartelasDisponiveis >= 40 ? "" : "collapse"} value="40">40</option>
                  <option class={this.state.cartelasDisponiveis >= 50 ? "" : "collapse"} value="50">50</option>
                  <option class={this.state.cartelasDisponiveis >= 100 ? "" : "collapse"} value="100">100</option>
                  <option class={this.state.cartelasDisponiveis >= 200 ? "" : "collapse"} value="200">200</option>
                  <option class={this.state.cartelasDisponiveis >= 500 ? "" : "collapse"} value="500">500</option>
                </select>
              </div>
              <div class="col">
                <span class="font-weight-bold">Cambistas ativos: </span><br />
                <select disabled={this.state.cartelasDisponiveis < 10} onChange={this.setCambista} class="custom-select">
                  <option selected>Nenhum...</option>
                  {this.state.cambistas.length > 0 ? this.state.cambistas.map(cambista => {
                    return <option value={JSON.stringify(cambista)}>{cambista.nome}</option>
                  }) : ""}
                </select>
              </div>
              <div class="col">
                <button class="mt-4 btn-fill btn btn-primary" disabled={this.state.cartelasDisponiveis < 10 || this.state.statusVenda} data-toggle="modal" data-dismiss="modal" data-target="#exampleModal3" >GERAR</button>
              </div>
            </div>
            <div class="row pl-5">
              <span class="font-weight-bold">Disponivel :</span>  <span class="font-weight-bold text-danger">{this.state.cartelasDisponiveis}</span>
            </div>
            <div class="row pl-5">

              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">Série</th>
                    <th scope="col">Cambista</th>
                    <th scope="col">Quantidade</th>
                    <th scope="col">Data</th>
                    <th scope="col">Criar pedidos</th>
                    {this.state.user.isApp? <div></div>: <th scope="col">Vender como avulsa</th>}
                  </tr>
                </thead>
                <tbody>
                  {this.state.subSeries.length > 0 ? this.state.subSeries.map((serie, index) => {
                    if (serie.cambistaId) {
                      return (
                        <tr accessKey={JSON.stringify(serie)}>
                          {serie.isPanfleto?
                           <th scope="row"><button disabled={serie.cartelas.length == 0 || this.state.statusVenda} className={serie.printNumber && serie.printNumber > 0 ? "btn-fill btn btn-danger" : "btn-fill btn btn-success"} accessKey={JSON.stringify({ serie, index: index + 1 })} onClick={this.imprimirSeriePanfleto}>{`Série QRCODE: ${index + 1}`}</button></th>
                        :
                          <th scope="row"><button disabled={serie.cartelas.length == 0 || this.state.statusVenda} className={serie.printNumber && serie.printNumber > 0 ? "btn-fill btn btn-danger" : "btn-fill btn btn-success"} accessKey={JSON.stringify({ serie, index: index + 1 })} onClick={this.imprimirSerie}>{`Imprimir série: ${index + 1}`}</button></th>
                        }
                         

                          <td accessKey={JSON.stringify(serie)}>{serie.cambistaId.nome}</td>
                          <td accessKey={JSON.stringify(serie)}>{serie.cartelas.length}</td>
                          <td accessKey={JSON.stringify(serie)}>{this.formatDate(serie.data)}</td>
                          {serie.isPanfleto? 
                          <div></div>
                          :
                          <td><button disabled={serie.cartelas.length == 0 || this.state.statusVenda} class="btn-fill btn btn-danger" accessKey={serie._id} onClick={this.setCambistaCriarPedidos}>Criar pedidos</button></td>
                          }
                          {serie.isPanfleto? 
                          <div></div>
                          :
                           this.state.user.isApp? <div></div>:  <td><button disabled={serie.cartelas.length == 0 || this.state.statusVenda} class="btn-fill btn btn-info" accessKey={JSON.stringify(serie)} onClick={this.setCurrentSerie.bind(this)} data-toggle="modal" data-dismiss="modal" data-target="#exampleModal2" >Receber tudo como avulso</button></td>
                          }
                          </tr>)
                    }
                  }) : ""}

                </tbody>
              </table>
            </div>
          </div>



          : <div className="p-5 rounded text-danger bg-dark">

            <h3 className=" text-warning">                   <i class="fas fa-lock"></i> Funcionalidade temporariamente bloqueada para Celulares e Tablets!</h3>
            <h4 className=" text-danger">Por favor, use um computador com internet!</h4>
          </div>}

      </div>

    </div>
  }

  render() {
    return (
      <GerenteTemplate label="Imprimir cartelas">
        {this.state.user.status ?

          this.conteudoValido()

          :
          <div className="rounded p-5 m-5 bg-dark">
            <h3 className="text-warning">Usuário bloqueado. Favor tratar com a gerência.</h3>
          </div>
        }

      </GerenteTemplate>
    );
  }
}

export default ImprimirCartelasAvulsas;
